import { TimeZoneService } from './../../services/timezone.service';
import { FormErrorHandler } from 'src/app/modules/shared/helpers/form-error-handler.helper';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService, TreeNode } from 'primeng/api';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { ReportsAllFiltersApplyModes, ReportsAllFiltersAppyModels, typeReportsAllFiltersApplyModes } from 'src/app/reports/models/reports-all-filter-appy.models';
import { scrollToError } from '../../helpers/scroll-to-error.helper';
import { DatePipe } from '@angular/common';
import { AppMainService } from 'src/app/app-main.service';
import { ReportService } from 'src/app/reports/reportService';
import { Subject, takeUntil } from 'rxjs';
import { DashboardService } from '../../../../profile/dashboard/services/dashboard.service';
import { PermissionService } from 'src/app/service/permission.service';
import { ObjectNames } from 'src/app/shared/constants';
import { FINANCE_PROFITLOSS_DATE_RANGE_LIST } from '../../constants/date-range-list.constants';
import { DateRangeFilterService } from '../../services/date-range-filter.service';
import { ParseHelper } from '../../parse.helper';

@Component({
    selector: 'app-shared-summary-widget',
    templateUrl: './shared-summary-widget.component.html',
    styleUrls: ['./shared-summary-widget.component.scss'],
    providers: [DatePipe]
})

export class SharedSummaryWidgetComponent implements OnInit, OnChanges, OnDestroy {

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    @Input() selectedReportFilters: any = null;
    @Input() reloadContent: boolean = false;
    @Output() onReloadContent: EventEmitter<any> = new EventEmitter<any>();
    @Output() onLastReloadTime: EventEmitter<any> = new EventEmitter<Date>();
    @Input() selectedWindow: string = '';
    @Input() dashboardView: string = "";
    @Input() displayFilterPopup: boolean = false;
    @Output() onCloseFilterPopup: EventEmitter<any> = new EventEmitter<any>();
    @Output() onUpdateAllFilters: EventEmitter<ReportsAllFiltersAppyModels> = new EventEmitter<ReportsAllFiltersAppyModels>();

    summaryWidgetList: TreeNode[] = [
        {
            key: 'finance',
            label: "Finance",
            selectable: false,
            children: [
                {
                    key: 'total_income',
                    label: 'Total Income',
                    selectable: true,
                    data: {
                        key: 'total_income',
                        label: 'Total Income'
                    }
                },
                {
                    key: 'total_COGS',
                    label: 'Total COGS',
                    selectable: true,
                    data: {
                        key: 'total_COGS',
                        label: 'Total COGS'
                    }
                },
                {
                    key: 'total_expense',
                    label: 'Total Expense',
                    selectable: true,
                    data: {
                        key: 'total_expense',
                        label: 'Total Expense'
                    }
                },
                {
                    key: 'accounts_receivable',
                    label: 'Accounts Receivable',
                    selectable: true,
                    data: {
                        key: 'accounts_receivable',
                        label: 'Accounts Receivable'
                    }
                },
                {
                    key: 'accounts_payable',
                    label: 'Accounts Payable',
                    selectable: true,
                    data: {
                        key: 'accounts_payable',
                        label: 'Accounts Payable'
                    }
                }
            ]
        }
    ];

    asOfDateReports: string[] = ['accounts_payable','accounts_receivable'];
    filterDataByTime = FINANCE_PROFITLOSS_DATE_RANGE_LIST;

    summaryWidgetThemes = [
        { name: "dark", color: "#3b3b48" },
        { name: "turquoise", color: "#04838f" },
        { name: "green", color: "#1e8455" },
        { name: "blue", color: "#2461cc" },
        { name: "rose", color: "#79425a" },
        { name: "teal", color: "#427976" },
        { name: "bluegrey", color: "#37474f" },
        { name: "purple", color: "#5d4279" }
    ];

    reportsAllFiltersApplyModes = ReportsAllFiltersApplyModes;
    reportName: string = "";
    filterPopupHeader: string = "Summary Widget";
    savedReportFilters: any = null;
    filterForm: FormGroup = new FormGroup({});
    isUnsavedData: boolean = false;
    detailsFormErrors: any = {};
    formErrorHandler: FormErrorHandler = new FormErrorHandler();

    //Report
    loadingReport: boolean = false;
    reportResultValue: number = 0;
    reportIcon: string = "pi pi-chart-line";

    constructor(
        private formBuilder: FormBuilder,
        private timezoneService: TimeZoneService,
        private datePipe: DatePipe,
        private messageService: MessageService,
        private appMainService: AppMainService,
        private reportService: ReportService,
        private dashboardService: DashboardService,
        private permissionService: PermissionService,
        private dateRangeFilterService: DateRangeFilterService
    ){}

    ngOnInit(): void {
        this.setPermissions();
        this.initFieldForm();
    }

    setPermissions(): void {
        const userPermissions = this.permissionService.getPermissionData();

        if (userPermissions.length) {
            this.summaryWidgetList.map(report=>{
                switch(report.key){
                    case 'finance':
                    const financeUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.FINANCE);
                    const financeMenuPermission = financeUserPermission ? (financeUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;
                    report['styleClass'] = financeMenuPermission ? "" : "treeselect-row-hidden";
                    break;
                }
            })
        }
    }

    ngOnChanges(changes: SimpleChanges){

        if(changes?.selectedReportFilters && changes.selectedReportFilters?.currentValue){
            this.selectedReportFilters = changes.selectedReportFilters?.currentValue||false;
            this.savedReportFilters = ParseHelper.DeepCopy(this.selectedReportFilters);
            this.setFilterDetails(true);
            if(this.selectedReportFilters?.summaryWidgetTitle){
                this.reportName = this.selectedReportFilters?.summaryWidgetTitle;
            }
        }

        if(changes?.displayFilterPopup){
            this.displayFilterPopup = changes.displayFilterPopup?.currentValue||false;
            if(this.displayFilterPopup){
                this.setFilterDetails();
            }
        }

        if(changes?.reloadContent && changes?.reloadContent?.currentValue){
            this.reloadContent = true;
            this.selectedReportFilters = ParseHelper.DeepCopy(this.savedReportFilters);
            this.reApplyTheme();
            this.setFilterDetails(true);
        }
    }

    setFilterDetails(reloadReport: boolean = false){
        this.initFieldForm();
        const widgetList = this.getFlatArrayFormChilren(this.summaryWidgetList)||[];
        const selectedWidget = widgetList.find(widget => widget.key == this.selectedReportFilters?.summaryWidgetCode)||null;
        const selectedDateFilter = this.filterDataByTime.find(d=> d.code === this.selectedReportFilters.dateFilter);
        this.reportName = this.selectedReportFilters?.summaryWidgetTitle;
        this.filterForm.patchValue({
            selectedWidget: selectedWidget,
            selectedDateFilter: selectedDateFilter,
            selectedTheme: this.selectedReportFilters?.summaryWidgetTheme,
            reportName: this.selectedReportFilters?.summaryWidgetTitle,
            dateFrom: this.selectedReportFilters?.fromDate ? new Date(this.selectedReportFilters?.fromDate) : null,
            dateTo:  this.selectedReportFilters?.toDate ? new Date(this.selectedReportFilters?.toDate) : null
        });
        this.changeRange({value: selectedDateFilter});

        if(reloadReport){
            switch (this.selectedReportFilters?.summaryWidgetCode) {
                case 'total_income':
                case 'total_COGS':
                case 'total_expense':
                    this.getAllProfitLossReport();
                    break;
                case 'accounts_receivable':
                    this.getAccountsReceivable();
                    break;
                case 'accounts_payable':
                    this.getAccountsPayable();
                    break;
                default:
                    break;
            }
        }
    }

    getFlatArrayFormChilren(members: any[]){
        let children = [];
        return members.map(m => {
          if (m.children && m.children.length) {
            children = [...children, ...m.children];
          }
          return m;
        }).concat(children.length ? this.getFlatArrayFormChilren(children) : children);
    }

    initFieldForm(){
        this.detailsFormErrors = {};
        this.isUnsavedData = false;
        this.filterForm = this.formBuilder.group({
            selectedWidget: [null, [Validators.required]],
            selectedDateFilter: [null, [Validators.required]],
            dateFrom: [null, [Validators.required]],
            dateTo: [null],
            selectedTheme: [null],
            reportName: ["", [Validators.required, Validators.maxLength(100)]],
        });

        this.formErrorHandler.handleErrors(this.filterForm, this.detailsFormErrors, {
            selectedWidget: {
                required: "Select any widget",
            },
            selectedDateFilter: {
                required: "Select date range",
            },
            selectedTheme: {
                required: "Select background"
            },
            reportName: {
                required: "Enter summary title",
                maxLength: "Please enter less than 100 characters"
            }
        });
    }

    selectTheme(theme: string){
        this.filterForm.patchValue({
            selectedTheme: theme
        })
    }

    changeWidget($event){
        this.generateName(null,$event.node);
    }

    generateName(selectedDateFilter: any = null, selectedWidget: any){
        selectedDateFilter = selectedDateFilter||this.filterForm.value.selectedDateFilter;
        selectedWidget = selectedWidget||this.filterForm.value.selectedWidget;

        let reportName = selectedDateFilter?.code!='custom'  ? `${selectedDateFilter?.name||selectedDateFilter?.label} ` : "";
        reportName = `${reportName}${(selectedWidget?.label||"")}`;

        this.filterForm.patchValue({
            reportName: reportName
        })
    }

    changeRange($event, reportNameUpdate: boolean = false): void {
        const selectedDateFilter = $event.value;
        reportNameUpdate && this.generateName(selectedDateFilter, null);
        let dateFrom = null;
        let dateTo = null;

        let data = {
            code: selectedDateFilter.code,
            fromDate: this.filterForm.getRawValue().dateFrom,
            toDate: this.filterForm.getRawValue().dateTo
        };
        const dateRange = this.dateRangeFilterService.changeRange(data);
        dateFrom = dateRange?.fromDate;
        dateTo = dateRange?.toDate;

        this.filterForm.patchValue({
            dateFrom: dateFrom,
            dateTo: dateTo
        });
    }

    changeRange2($event, reportNameUpdate: boolean = false): void {
        const selectedDateFilter = $event.value;
        reportNameUpdate && this.generateName(selectedDateFilter, null);
        let today = this.timezoneService.showDateTimeWithZone(new Date());
        let todayCopy = this.timezoneService.showDateTimeWithZone(new Date());
        let dateFrom = null;
        let dateTo = null;
        if (selectedDateFilter.code == 'all') {
            dateFrom = null;
            dateTo = null;
        }
        else if (selectedDateFilter.code == 'today') {
            dateFrom = today;
            dateTo = today;
        } else if (selectedDateFilter.code == 'yesterday') {
            let yesterday = todayCopy;
            yesterday.setDate(todayCopy.getDate() - 1);

            dateFrom = yesterday;
            dateTo = yesterday;
        } else if (selectedDateFilter.code == 'this month') {
            let firstday = todayCopy;
            firstday.setDate(1);

            dateFrom = firstday;
            dateTo = today;
        } else if (selectedDateFilter.code == 'last month') {
            dateFrom = new Date(today.getFullYear(), today.getMonth() - 1, 1);
            dateTo = new Date(today.getFullYear(), today.getMonth(), 0);
        } else if (selectedDateFilter.code == 'last 7 days') {
            let seven = todayCopy;
            seven.setDate(todayCopy.getDate() - 7);

            dateFrom = seven;
            dateTo = today;
        } else if (selectedDateFilter.code == 'last 15 days') {
            let fifteen = todayCopy;
            fifteen.setDate(todayCopy.getDate() - 15);

            dateFrom = fifteen;
            dateTo = today;
        } else if (selectedDateFilter.code == 'last 30 days') {
            let thirty = todayCopy;
            thirty.setDate(todayCopy.getDate() - 30);

            dateFrom = thirty;
            dateTo = today;
        } else if (selectedDateFilter.code == 'last 60 days') {
            let sixty = todayCopy;
            sixty.setDate(todayCopy.getDate() - 60);

            dateFrom = sixty;
            dateTo = today;
        } else if (selectedDateFilter.code == 'last 90 days') {
            let ninety = todayCopy;
            ninety.setDate(todayCopy.getDate() - 90);

            dateFrom = ninety;
            dateTo = today;
        } else if (selectedDateFilter.code == 'custom') {

            if (this.filterForm.getRawValue().dateFrom && this.filterForm.getRawValue().dateTo) {
                dateFrom = new Date(this.filterForm.getRawValue().dateFrom);
                dateTo = new Date(this.filterForm.getRawValue().dateTo);
            } else {
                dateFrom = null;
                dateTo = null;
            }

        } else {
            dateFrom = null;
            dateTo = null;
        }

        this.filterForm.patchValue({
            dateFrom: dateFrom,
            dateTo: dateTo
        });
    }

    cancelFilterPopup(){
        this.displayFilterPopup = false;
        this.onCloseFilterPopup.emit();
    }

    applyAllFilters(applyMode: typeReportsAllFiltersApplyModes) {

        if (this.filterForm.invalid) {
            this.formErrorHandler.showErrorOnSubmit();
            scrollToError();
            return; //Return if form invalid
        }

        const formValue = this.filterForm.getRawValue();

        let allFiltersValue: ReportsAllFiltersAppyModels = {
            applyMode: applyMode,
            dateFilter: {
                label: formValue.selectedDateFilter?.label,
                code: formValue.selectedDateFilter?.code,
                fromDate: formValue.dateFrom,
                toDate: formValue.dateTo
            },
            summaryWidgetCode: formValue.selectedWidget.key,
            summaryWidgetTheme: formValue.selectedTheme,
            summaryWidgetTitle: formValue.reportName
        }

        this.selectedReportFilters = {
            ...this.selectedReportFilters,
            ...allFiltersValue,
            ...allFiltersValue.dateFilter,
            dateFilter: allFiltersValue.dateFilter.code
        }
        if(applyMode==ReportsAllFiltersApplyModes.applySave){
            this.savedReportFilters = ParseHelper.DeepCopy(this.selectedReportFilters);
        }
        this.setFilterDetails(true);

        this.onUpdateAllFilters.emit(allFiltersValue);
        this.cancelFilterPopup();
    }

    reApplyTheme(){
        let allFiltersValue: any = {
            applyMode: ReportsAllFiltersApplyModes.applyOnly,
            summaryWidgetTheme: this.selectedReportFilters.summaryWidgetTheme
        }
        this.onUpdateAllFilters.emit(allFiltersValue);
    }

    getAllProfitLossReport() {
        this.loadingReport = true;
        this.reportService
            .allProfitLossReportCustomize("profitandloss", this.formatDate2(this.filterForm.getRawValue().dateFrom), this.formatDate(this.filterForm.getRawValue().dateTo), "TotalOnly")
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(
                (res) => {
                    this.onReloadContent.emit(false);
                    this.loadingReport = false;
                    this.reportResultValue = 0;
                    if(res?.length>0){
                        switch(this.selectedReportFilters?.summaryWidgetCode){
                            case 'total_income':
                                const income = res.find(r=> r.financialAccountTypeNumber === 20000);
                                this.reportResultValue = income?.balance||0;
                                break;
                            case 'total_COGS':
                                const cogs = res.find(r=> r.financialAccountTypeNumber === 60000);
                                this.reportResultValue = cogs?.balance||0;
                                break;
                            case 'total_expense':
                                const expense = res.find(r=> r.financialAccountTypeNumber === 40000);
                                this.reportResultValue = expense?.balance||0;
                                break;
                        }
                    }
                },
                (err) => {
                    this.onReloadContent.emit(false);
                    this.loadingReport = false;
                }
            );
    }

    getAccountsReceivable() {
        this.loadingReport = true;
        const dateFilterType = this.filterForm.value.selectedDateFilter?.code=='custom' ? 'Custom' : 'AsOfDate';
        this.dashboardService
            .getFinanceAccountReceivable(this.formatDate2(this.filterForm.getRawValue().dateFrom), this.formatDate(this.filterForm.getRawValue().dateTo), dateFilterType)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(
                (res) => {
                    this.onReloadContent.emit(false);
                    this.loadingReport = false;
                    const totalAmount = res?.length>0 ? res.reduce((sum, invoice) => sum + invoice.totalDueAmount, 0) : 0;
                    this.reportResultValue = totalAmount;
                },
                (err) => {
                    this.onReloadContent.emit(false);
                    this.loadingReport = false;
                }
            );
    }

    getAccountsPayable() {
        this.loadingReport = true;
        const dateFilterType = this.filterForm.value.selectedDateFilter?.code=='custom' ? 'Custom' : 'AsOfDate';
        this.dashboardService
            .getFinanceAccountPayable(this.formatDate2(this.filterForm.getRawValue().dateFrom), this.formatDate(this.filterForm.getRawValue().dateTo), dateFilterType)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(
                (res) => {
                    this.onReloadContent.emit(false);
                    this.loadingReport = false;
                    const totalAmount = res?.length>0 ? res.reduce((sum, invoice) => sum + invoice.totaldueamount, 0) : 0;
                    this.reportResultValue = totalAmount;
                },
                (err) => {
                    this.onReloadContent.emit(false);
                    this.loadingReport = false;
                }
            );
    }

    private formatDate(date: Date): any {
        date = date ? date : new Date();
        let utcDate = this.datePipe.transform(this.timezoneService.saveDateTimeWithZone(date), "MM-dd-yyyy");
        return utcDate;
    }

    private formatDate2(date: Date): any {
        let utcDate = this.datePipe.transform(date, "MM-dd-yyyy");
        return utcDate;
    }

    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }
}
